module.exports = __webpack_public_path__ + "19db4fef3108e24a04bb514a8d679e68.pdf";